// lane-active-item.js
/**
 * Manages the "active" item in a scrolling lane.
 *
 * @property {import('vue').Component} component - The Vue component instance.
 * @property {number|null} currentActiveIndex - Index of the currently active item.
 * @property {{active: number|null, prev: number|null, next: number|null, prev2: number|null, next2: number|null}} previousIndices - Previously assigned indices for styling.
 */
export default class LaneActiveItem {
	constructor(component) {
		this.component = component;
		this.previousIndices = {
			active: null,
			prev: null,
			next: null,
			prev2: null,
			next2: null,
		};
		this.currentActiveIndex = null;
	}

	updateActiveItem() {
		let minDistance = Infinity;
		let activeIndex = null;

		if (this.component.orientation === 'vertical') {
			const laneCenter = this.component.lane.clientHeight / 2;
			const scrollTop = this.component.lane.scrollTop;
			this.component.childs.forEach((child, i) => {
				const childTop = child.offsetTop - scrollTop;
				const centerY = childTop + child.offsetHeight / 2;
				const dist = this.component.viewportActiveItemTrigger === 'center'
					? Math.abs(laneCenter - centerY)
					: Math.abs(0 - childTop);

				if (dist < minDistance) {
					minDistance = dist;
					activeIndex = i;
				}
			});
		} else {
			const laneCenter = this.component.lane.clientWidth / 2;
			const scrollLeft = this.component.lane.scrollLeft;
			this.component.childs.forEach((child, i) => {
				const childLeft = child.offsetLeft - scrollLeft;
				const centerX = childLeft + child.offsetWidth / 2;
				const dist = this.component.viewportActiveItemTrigger === 'center'
					? Math.abs(laneCenter - centerX)
					: Math.abs(0 - childLeft);

				if (dist < minDistance) {
					minDistance = dist;
					activeIndex = i;
				}
			});
		}

		if (activeIndex !== this.currentActiveIndex) {
			this.updateClasses(activeIndex);
			this.currentActiveIndex = activeIndex;
		}
	}

	updateClasses(activeIndex) {
		const { childs } = this.component;
		// Vorherige Klasse entfernen
		Object.values(this.previousIndices)
			.filter((i) => i !== null && childs[i])
			.forEach((i) =>
				childs[i].classList.remove(
					'ho-lane-item-active',
					'ho-lane-item-prev',
					'ho-lane-item-next',
					'ho-lane-item-prev-2',
					'ho-lane-item-next-2'
				)
			);

		const activeItem = childs[activeIndex];
		if (activeItem) {
			activeItem.classList.add('ho-lane-item-active');

			const prevIndex = activeIndex - 1;
			const nextIndex = activeIndex + 1;
			const prevIndex2 = activeIndex - 2;
			const nextIndex2 = activeIndex + 2;

			if (childs[prevIndex]) childs[prevIndex].classList.add('ho-lane-item-prev');
			if (childs[nextIndex]) childs[nextIndex].classList.add('ho-lane-item-next');
			if (childs[prevIndex2]) childs[prevIndex2].classList.add('ho-lane-item-prev-2');
			if (childs[nextIndex2]) childs[nextIndex2].classList.add('ho-lane-item-next-2');

			this.previousIndices = {
				active: activeIndex,
				prev: childs[prevIndex] ? prevIndex : null,
				next: childs[nextIndex] ? nextIndex : null,
				prev2: childs[prevIndex2] ? prevIndex2 : null,
				next2: childs[nextIndex2] ? nextIndex2 : null,
			};
		}
	}
}
